export default {
  SET_LISTA (state, lista) {
    if (state.paginaAtual === 1) {
      state.lista = lista
      return
    }
    state.lista = state.lista.concat(lista)
  },

  SET_TOTAL_ITENS (state, totalItens) {
    state.totalItens = totalItens
    state.todosItensCarregados = state.totalItens <= state.lista.length
  },

  SET_PAGINA_ATUAL (state, pagina) {
    state.paginaAtual = pagina
  },

  INCREMENTAR_PAGINA_ATUAL (state) {
    state.paginaAtual++
  },

  SET_ESTA_CARREGANDO (state, value) {
    state.estaCarregando = value
  },

  SET_ITEM_SELECIONADO_ID (state, value) {
    state.itemSelecionadoID = value
  },

  SET_LIVRO_SELECIONADO_ID (state, value) {
    state.livroSelecionadoID = value
  },

  SET_ITEM_SELECIONADO (state, value) {
    state.itemSelecionado = value
  },

  SET_PLANEJAMENTO (state, value) {
    state.itemSelecionado.planejamento_licao_id = value
  },

  SET_DESCRICAO (state, value) {
    state.itemSelecionado.descricao = value
  },

  SET_NUMERO (state, value) {
    state.itemSelecionado.numero = value
  },

  SET_OBSERVACAO (state, value) {
    state.itemSelecionado.observacao = value
  },

  SET_SITUACAO (state, value) {
    state.itemSelecionado.situacao = value
  },

  LIMPAR_ITEM_SELECIONADO (state) {
    state.itemSelecionadoID = null
    state.itemSelecionado = {
      id: null,
      planejamento_licao_id: null,
      descricao: null,
      numero: '',
      observacao: null,
      situacao: null
    }
  }
}
